import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "../Pages/Home/Home";
import ProductDetails from "../Pages/Product/ProductDetails";
import FramedPrints from "../Pages/FramedPrints/FramedPrints";
import Order from "../Pages/Order/Order";
import ScrollToTop from "../Common/ScrollToTop";
import ThankYou from "../Pages/ThankYou/ThankYou";
import ThankYou2 from "../Pages/ThankYou/ThankYou2";
import NewForm from "../Pages/New-form/NewForm";

const WebRoutes = () => {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/:id" element={<Home />} />
        <Route path="/product" element={<ProductDetails />} />
        <Route path="/framed-prints" element={<FramedPrints />} />
        <Route path="/order" element={<Order />} />
        <Route path="/thank-you" element={<ThankYou />} />
        <Route path="/thank-you-page" element={<ThankYou2 />} />
        <Route path="/new-form" element={<NewForm />} />
      </Routes>
    </BrowserRouter>
  );
};

export default WebRoutes;
